import {Link} from "react-router-dom";

function Footer() {
    return (
        <div className="container-fluid bg-primary text-light footer">
            <div className="footer_slop"/>

            <div className="footer-inner row">
                <div className="col-md-7 offset-md-1">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <p className="text-center">Made with 💚 by Jani</p>
                        <p className="text-center">Dieses Projekt ist in meiner Freizeit umgesetzt worden und wird auch
                            von mir privat gehostet!</p>
                    </div>
                </div>
                <div className="col-md-1 d-flex justify-content-center">
                    <div className="vertical-line"/>
                </div>
                <div className="col-md-1 d-flex justify-content-center align-items-center flex-column">
                    <div><Link to={"/about"} className="text-light">Mehr Info!</Link></div>
                    <div><Link to={"/about"} className="text-light">Datenschutzerklärung</Link></div>
                    <div><Link to={"/about"} className="text-light">Impressum</Link></div>
                </div>
            </div>
        </div>
    )
}

export default Footer;